query PreviewAccountDeletion($targetAccountId: ID!) {
  preview: StreamToolsPreviewAccountDeletion(targetAccountId: $targetAccountId) {
    accountId
    email
    staffAccount
    loginKept
    suspended
    ownedStreams
    liveStreams
    shopifyLinkedBoards
    scheduledRunAt
    deletionStatus
  }
}
